import React from "react";
import { MessageSquare, Star, Award, Clock } from "lucide-react";

const CommentHistory = ({ comments = [] }) => {
  if (!comments || comments.length === 0) return null;

  const fmtDate = (dStr) => {
    if (!dStr) return "";
    try {
      return new Date(dStr).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (e) {
      return dStr;
    }
  };

  return (
    <div className="mt-4 pt-3 border-t border-gray-100">
      <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 flex items-center gap-1.5">
        <MessageSquare className="w-3.5 h-3.5" />
        Faculty Feedback & Assessments ({comments.length})
      </h4>
      <div className="space-y-2.5">
        {comments.map((c, idx) => (
          <div key={idx} className="bg-slate-50 border border-slate-200 rounded-xl p-3 text-xs">
            <div className="flex items-center justify-between gap-2 mb-1.5">
              <div className="flex items-center gap-2">
                <span className="font-bold text-slate-800">
                  {c.subrole || (c.from_source === "HOD" ? "Head of Department (HOD)" : "Faculty Member")}: {c.from || c.professorEmail || "Evaluator"}
                </span>
              </div>
              <span className="text-[11px] text-slate-400 flex items-center gap-1">
                <Clock className="w-3 h-3" /> {fmtDate(c.timestamp)}
              </span>
            </div>

            {/* Ratings / Scores */}
            {c.assessment && (c.assessment.rating || c.assessment.numericScore || c.assessment.facultyDecision) && (
              <div className="flex flex-wrap items-center gap-3 my-1.5 p-2 bg-white rounded-lg border border-slate-100">
                {c.assessment.rating && (
                  <div className="flex items-center gap-1 font-semibold text-amber-700">
                    <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-500" />
                    <span>{c.assessment.rating}</span>
                  </div>
                )}
                {c.assessment.numericScore !== null && c.assessment.numericScore !== undefined && (
                  <div className="flex items-center gap-1 font-bold text-blue-700">
                    <Award className="w-3.5 h-3.5 text-blue-500" />
                    <span>Score: {c.assessment.numericScore}/10</span>
                  </div>
                )}
                {c.assessment.facultyDecision && (
                  <span className={`px-2 py-0.5 rounded-md font-bold text-[10px] uppercase ${
                    c.assessment.facultyDecision.toLowerCase().includes("approve") || c.assessment.facultyDecision.toLowerCase().includes("complet")
                      ? "bg-emerald-100 text-emerald-800"
                      : "bg-rose-100 text-rose-800"
                  }`}>
                    {c.assessment.facultyDecision}
                  </span>
                )}
              </div>
            )}

            {/* Comment Text */}
            <p className="text-slate-700 whitespace-pre-wrap mt-1 leading-relaxed">
              {c.text}
            </p>

            {/* Signature */}
            {c.signature && (
              <div className="mt-2 pt-1 border-t border-slate-100 flex justify-end">
                <img
                  src={c.signature}
                  alt="Faculty Signature"
                  className="h-6 object-contain"
                  title="Electronic Signature Attached"
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommentHistory;
